var $ = require('jquery');

/**
 * Help links that are displayed in the toolbar help dropdown menu, as well as
 * help search
 */
(function() {
    'use strict';

    var HelpLinks;

    HelpLinks = Klazz.extend({
        element: null,
        messages: {

        },
        helpLinksData: null,

        initialize: function(element) {
            this.element = $(element);

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.helptoolbar);

            this._initHelpLinksData();
        },

        _initHelpLinksData: function() {
            this.helpLinksData = [{
                id: 'defaultView',
                title: this.messages.help.title,
                desc: this.messages.help.desc
            }, {
                id: 'guidedTour',
                title: this.messages.tour.title,
                desc: this.messages.tour.desc,
                action: function() {
                    diy.editor.guidance.start();
                }
            }, {
                id: "contactView",
                title: this.messages.contact.title,
                desc: this.messages.contact.desc
            }];
        },

        render: function() {
            var $helpLinks, i, current, $item;

            $helpLinks = $('<div class="diye-help-links"></div>')
                .appendTo(this.element);

            for (i = 0; i < this.helpLinksData.length; ++i) {
                current = this.helpLinksData[i];

                $item = $helpLinks.append(
                    '<div class="help-link">' +
                        '<a href="JavaScript:;" data-index="' + i + '">' +
                            '<div class="help-link-content">' +
                                '<span class="icon icon-' + current.id + '"></span>' +
                                '<h3>' + current.title + '</h3>' +
                                '<p>' + current.desc + '</p>' +
                            '</div>' +
                        '</a>' +
                    '</div>'
                );
            }

            $helpLinks.find('a').bind('click', $.proxy(this._onHelpLinkClick, this));


        },

        _onVersionClick: function (e) {
            var topic = 'changelog';
            cms.help.GuidedAssistant.getInstance()._openHelpTopic(topic);
            this.element.trigger('helplinksclick', { helpLinkId: topic });
        },
        _onHelpLinkClick: function(e) {
            var linkIndex = $(e.currentTarget).attr('data-index'),
                linkData = this.helpLinksData[linkIndex],
                linkId = linkData.id;


            if (typeof linkData.action === 'function') {
                linkData.action();
            } else {
                this._openHelp(linkId);
            }

            this.element.trigger('helplinksclick', {
                helpLinkId: linkId
            });
        },

        _openHelp: function(tab) {
            cms.help.GuidedAssistant._instance.showHelpWindowTab(
                cms.help.GuidedAssistant._instance._options.controller[tab]
            );
        }
    });

    module.exports = HelpLinks;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/help/helpLinks.js
 ** module id = 853
 ** module chunks = 0
 **/